import i18n from 'i18next';

import { addModal } from '@/exceed';

export default async ({ item, deleteLearningObjective }) => {
  const { data } = item;
  
  const { type } = await addModal(
    {
      title: i18n.t('learning-objectives.modal.delete-title'),
      body: i18n.t('learning-objectives.modal.delete-body'),
      hasCloseButton: true,
      actions: [
        {
          action: 'cancel',
          variant: 'ghost',
          size: 'small',
          element: 'button',
          text: i18n.t('cancel'),
        },
        {
          action: 'delete',
          size: 'medium',
          color: 'negative',
          element: 'button',
          text: i18n.t('learning-objectives.modal.delete-title'),
        }
      ],
    },
  );

  if (type !== 'delete') return;

  deleteLearningObjective(data)
};
